import React from 'react'
import Panel from 'muicss/lib/react/panel'
import Container from 'muicss/lib/react/container'
import RaisedButton from 'material-ui/RaisedButton'
import { connect } from 'react-redux'
import CheckIcon from 'material-ui/svg-icons/action/check-circle'
import CircleIcon from 'material-ui/svg-icons/toggle/radio-button-unchecked'
import BadIcon from 'material-ui/svg-icons/action/highlight-off'
import { reduxForm } from 'redux-form'
import { missionAnswerInit, selectCampaign } from '../../actions'
import MissionPage from '../MissionShow/MissionPage'

const styles = {
  icons: {
    marginTop: '10px',
    marginBottom: '10px',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  icon: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

const iconHelp = (Icon, color, text) => (
  <div style={styles.icon}>
    <span styles={styles.leftIcon}>
      <Icon
        style={{
          color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    </span>
    <span styles={styles.rightIcon}>
      { text }
    </span>
  </div>
)

class MissionShow extends React.Component {

  render() {
    const { name, mission_pages } = this.props
    return (
      <Container>
        <Panel className="modal-panel">
          <h1 style={{ textAlign: 'center' }}>{`${name}`}</h1>
          <div style={styles.icons}>
            { iconHelp(CheckIcon, 'green', 'Contestada y es correcta') }
            { iconHelp(BadIcon, 'red', 'Contestada pero es incorrecta') }
            { iconHelp(CircleIcon, 'green', 'No conestada pero es la correcta') }
            { iconHelp(CircleIcon, '', 'No conestada') }
          </div>
          <div>
            {
              this.props.real_answers.map((page) => {
                let real_answer = null
                this.props.my_answers.forEach((x) => {
                  if (x.id === page.id) {
                    real_answer = x
                  }
                })
                return (
                  <MissionPage
                    key={page.id}
                    mission_page={{ ...page }}
                    real_answer={real_answer}
                  />
                )
              })
            }
          </div>
          <div style={styles.icons}>
            <RaisedButton
              style={{ marginTop: '10px', minWidth: '400px' }}
              onClick={this.props.selectCampaign(this.props.campaign)}
              label="Cerrar y Continuar" primary
              onTouchTap={this.finishMission}
            />
          </div>
        </Panel>
      </Container>
    )
  }
}

MissionShow.propTypes = {
  my_answers: React.PropTypes.arrayOf(React.PropTypes.shape({})),
  real_answers: React.PropTypes.arrayOf(React.PropTypes.shape({})),
  selectCampaign: React.PropTypes.func,
  campaign: React.PropTypes.shape({
    id: React.PropTypes.string,
  }),
}

const mapStateToProps = state => ({
  campaign: state.campaigns.selectedCampaign,
  name: state.missions.selectedMission.name,
  my_answers: state.missions.answerMission.answer.mission_pages || [],
  real_answers: state.missions.answerMission.progress.pages_to_answer || [],
})

const mapDispatchToProps = dispatch => ({
  missionAnswerInit: () => dispatch(missionAnswerInit()),
  selectCampaign: campaign => () =>
    dispatch(selectCampaign(campaign)),
})

export default reduxForm({
  form: 'MissionAnswerForm',
  initialValues: { enabled: true },
})(connect(mapStateToProps, mapDispatchToProps)(MissionShow))



// WEBPACK FOOTER //
// ./src/components/MissionShowReview/index.jsx